import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ParkingListItemComponent } from './parking-list-item/parking-list-item.component'
import { ParkingSearchBarComponent } from './parking-search-bar/parking-search-bar.component'
import { SelectVehiclesComponent } from './select-vehicles/select-vehicles.component'
import { RouterModule } from '@angular/router'
import { CarouselModule } from 'ngx-bootstrap/carousel'
import { CoreModule } from '../core/core.module'
import { ParkingListItemClassicComponent } from './parking-list-item-classic/parking-list-item-classic.component'
import { ParkingListItemBookupComponent } from './parking-list-item-bookup/parking-list-item-bookup.component'
import { PayfastBookingFormComponent } from './payfast-booking-form/payfast-booking-form.component'
import { ReactiveFormsModule } from '@angular/forms'

@NgModule({
    declarations: [ParkingListItemComponent, ParkingSearchBarComponent, SelectVehiclesComponent, ParkingListItemClassicComponent, ParkingListItemBookupComponent, PayfastBookingFormComponent],
    exports: [ParkingListItemComponent, ParkingListItemClassicComponent, PayfastBookingFormComponent],
    imports: [CommonModule, RouterModule, CarouselModule, CoreModule, ReactiveFormsModule],
})
export class ParkingModule {}
